import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';

const UpdatedField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = restaurantForFullInfo?.updatedDate
		? `${moment(restaurantForFullInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				restaurantForFullInfo.updatedBy
		  }`
		: undefined;

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};

export default UpdatedField;
